export default __webpack_public_path__ + "static/media/PERF.27bab444.png";